import { useEffect, useState } from 'react'
import { useTranslation } from '~/common/hooks/useTranslation'
import BodyShop from '~/components/shared-components/BodyShop'
import ShopBoxCard from '~/views/app/Shop/components/ShopBoxCard'
import configs from '~/configs'
import { ifaceContractShop } from '~/blockchain/contract'
import { changeNetworkInMetamask } from '~/blockchain/metamask'
import { useShop } from '~/views/redux/hooks/useShop'
import {
  checkTransactionConfirmation,
  hexToNumberString,
  numberToHex,
} from '~/blockchain/provider'
import { useCommon } from '~/views/redux/hooks/useCommon'
import TransactionCompletedShop from '~/components/Modals/TransactionCompletedShop'
import { ethersWeb3Provider, providerOAS } from '~/blockchain/oas'
import { useSDK } from '@metamask/sdk-react'
import { useTheme } from '~/common/theme/redux/hooks/useTheme'
import { useAccountProfile } from '~/views/redux/hooks/useAccountProfile'
import { sendOASTransaction } from '~/helpers/oasTransaction'

export const GenesisBox = () => {
  const { sdk } = useSDK()
  const { t } = useTranslation()
  const { actions } = useShop()
  const [boxs, setBoxs] = useState()
  const [loadingModal, setLoadingModal] = useState(false)
  const [tema, setTema] = useState(1)
  const { actions: actionsCommon } = useCommon()
  const [txHash, setTxHash] = useState()
  const [boxActive, setBoxActive] = useState()

  const {
    actions: actionTheme,
    data: { user },
  } = useTheme()

  const { actions: actionsProfile } = useAccountProfile()
  const [isModalSuccessOpen, setIsModalSuccessOpen] = useState(false)

  const showModalSuccess = () => {
    setIsModalSuccessOpen(true)
  }

  const handleShare = () => {
    setIsModalSuccessOpen(false)
  }

  const handleCancelSuccess = () => {
    setIsModalSuccessOpen(false)
  }

  const handleBuyShop = async (box, quantity, closeModalCheckout = null) => {
    try {
      setLoadingModal(true)
      setBoxActive(box)
      const data = {
        address: user?.address_wallet,
        typeAsset: 'genesis_box',
        group: box?.id,
        amount: Number(quantity),
      }
      actions.signBuyShop(data, (res) => {
        buyGenesisBox(
          res.typeAsset,
          res.address,
          res.group,
          res.price,
          Number(quantity),
          res.deadline,
          res.signature,
          closeModalCheckout,
        )
      })
    } catch (error) {
      setLoadingModal(false)
      // eslint-disable-next-line
      console.log(error)
    }
  }
  const buyGenesisBox = async (
    typeAsset,
    address,
    group,
    priceInWei,
    number,
    deadline,
    sig,
    closeModalCheckout = null,
  ) => {
    try {
      if (localStorage.getItem('wallet') === 'OAS') {
        // const nonce = await ethersWeb3Provider
        //   .getSigner(providerOAS.accounts[0])
        //   .getTransactionCount()

        const transactionData = {
          from: providerOAS.accounts[0],
          data: ifaceContractShop.encodeFunctionData('buyItem', [
            typeAsset,
            address,
            0,
            group,
            priceInWei,
            number,
            deadline,
            sig,
          ]),
          to: configs.ADDRESS_SHOP,
          value: numberToHex(priceInWei),
          // nonce: nonce,
          // gasLimit: 21000,
        }
        const transaction = await sendOASTransaction(transactionData)
        // const signedTransaction = await providerOAS.request({
        //   method: 'eth_signTransaction',
        //   params: [data],
        // })

        // const transaction = await ethersWeb3Provider.sendTransaction(
        //   String(signedTransaction),
        // )
        checkTransactionConfirmation(transaction?.hash).then((r) => {
          if (r === 'confirmed') {
            // eslint-disable-next-line
            console.log(r, transaction?.hash)
            setLoadingModal(false)
            if (closeModalCheckout) {
              closeModalCheckout()
            }
            setTxHash(transaction?.hash)
            showModalSuccess()
            actionsProfile.getAccountProfile((res) => {
              actionTheme.updateInfoUser({
                ...res?.player_info,
              })
            })
          }
        })
      } else {
        await sdk.connect()
        await changeNetworkInMetamask(
          sdk.getProvider(),
          configs.NETWORK.chainId,
          setLoadingModal,
        )
        await sdk.connect()
        let networkId = await sdk
          .getProvider()
          .request({ method: 'eth_chainId', params: [] })
        networkId = hexToNumberString(networkId)

        if (parseInt(networkId) !== parseInt(configs.NETWORK.chainId)) return
        let nonce = await sdk.getProvider().request({
          method: 'eth_getTransactionCount',
          params: [user.address_wallet, 'latest'],
        });
        sdk
          .getProvider()
          .request({
            method: 'eth_sendTransaction',
            params: [
              {
                from: address,
                data: ifaceContractShop.encodeFunctionData('buyItem', [
                  typeAsset,
                  address,
                  0,
                  group,
                  priceInWei,
                  number,
                  deadline,
                  sig,
                ]),
                to: configs.ADDRESS_SHOP,
                value: numberToHex(priceInWei),
                nonce
              },
            ],
          })
          .then((txHash) => {
            checkTransactionConfirmation(txHash).then((r) => {
              if (r === 'confirmed') {
                // eslint-disable-next-line
                console.log(r, txHash)
                setLoadingModal(false)
                if (closeModalCheckout) {
                  closeModalCheckout()
                }
                setTxHash(txHash)
                showModalSuccess()
                actionsProfile.getAccountProfile((res) => {
                  actionTheme.updateInfoUser({
                    ...res?.player_info,
                  })
                })
              }
            })
          })
          .catch((error) => {
            setLoadingModal(false)
            // eslint-disable-next-line
            console.error(error)
          })
      }
    } catch (error) {
      setLoadingModal(false)
      // eslint-disable-next-line
      console.error(error)
    }
  }

  const loadBoxs = async () => {
    // let data = await ContractShop.methods.getListSale().call();
    actions.getDataShop({}, (res) => {
      let data = [
        {
          name: 'Genesis Box',
          type: 'Group A',
          id: 'a',
          img: './imgs/box/genesis_A.png',
          price: res[2]?.price,
          total: res[2]?.detail?.group_a?.total,
          remaining: res[2]?.detail?.group_a?.remaining,
        },
        {
          name: 'Genesis Box',
          type: 'Group B',
          id: 'b',
          img: './imgs/box/genesis_B.png',
          price: res[2]?.price,
          total: res[2]?.detail?.group_b?.total,
          remaining: res[2]?.detail?.group_b?.remaining,
        },
        {
          name: 'Genesis Box',
          type: 'Group C',
          id: 'c',
          img: './imgs/box/genesis_C.png',
          price: res[2]?.price,
          total: res[2]?.detail?.group_c?.total,
          remaining: res[2]?.detail?.group_c?.remaining,
        },
        {
          name: 'Genesis Box',
          type: 'Group D',
          id: 'd',
          img: './imgs/box/genesis_D.png',
          price: res[2]?.price,
          total: res[2]?.detail?.group_d?.total,
          remaining: res[2]?.detail?.group_d?.remaining,
        },
        {
          name: 'Genesis Box',
          type: 'Group E',
          id: 'e',
          img: './imgs/box/genesis_E.png',
          price: res[2]?.price,
          total: res[2]?.detail?.group_e?.total,
          remaining: res[2]?.detail?.group_e?.remaining,
        },
      ]
      setBoxs(data)
    })
  }

  useEffect(() => {
    actionsCommon.getTema({}, (res) => {
      setTema(res?.tema)
    })
    loadBoxs()
  }, [txHash])

  return (
    <BodyShop>
      <div className="flex flex-col justify-center items-center h-full">
        <div className="">
          <div className="title__shop mb-10">
            {t('shop.genesisBox').toUpperCase()}
          </div>
        </div>
        <div className="flex flex-wrap gap-5 justify-center max-w-[1396px]">
          {boxs?.map((data, index) => (
            <ShopBoxCard
              key={index}
              box={data}
              t={t}
              handleConfirm={handleBuyShop}
              loadingModal={loadingModal}
              tema={tema}
            />
          ))}
        </div>
      </div>
      <TransactionCompletedShop
        action={{
          isModalOpen: isModalSuccessOpen,
          handleOk: handleShare,
          handleCancel: handleCancelSuccess,
        }}
        t={t}
        name={`${boxActive?.name} (${boxActive?.type})`}
        store={'Shop'}
        txHash={txHash}
      />
    </BodyShop>
  )
}

export default GenesisBox
